export enum ProfileFieldType {
  WithTitle = 'withTitle',
  WithTitleWithoutLexeme = 'withTitleWithoutLexeme',
  Weight = 'weight',
  Height = 'Height',
  Age = 'age',
  SingleWithoutLexeme = 'singleWithoutLexeme',
  Single = 'single',
}

export enum GenderFieldLexeme {
  M = 'maleLexeme',
  F = 'femaleLexeme',
}
